/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetSyncExternalBranchJobStatusLogsAdminResponse } from '../models/GetSyncExternalBranchJobStatusLogsAdminResponse';
import type { Pagination1OfSyncExternalBranchJobAdminDto } from '../models/Pagination1OfSyncExternalBranchJobAdminDto';
import type { PostSyncExternalBranchJobsAdminRequest } from '../models/PostSyncExternalBranchJobsAdminRequest';
import type { SyncExternalBranchJobStatus } from '../models/SyncExternalBranchJobStatus';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SyncExternalBranchJobsService {
    /**
     * **Required Policy:** `CreateSyncExternalBranchJobs`
     * @returns any OK
     * @throws ApiError
     */
    public static postSyncExternalBranchJobAsyncAdmin({
        requestBody,
    }: {
        requestBody?: PostSyncExternalBranchJobsAdminRequest,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/syncexternalbranchjobs',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewSyncExternalBranchJobs`
     * @returns Pagination1OfSyncExternalBranchJobAdminDto OK
     * @throws ApiError
     */
    public static getSyncExternalBranchJobsAsyncAdmin({
        externalBranchId,
        status,
        fromDate,
        toDate,
        page,
        limit,
    }: {
        externalBranchId?: number,
        status?: SyncExternalBranchJobStatus,
        fromDate?: string,
        toDate?: string,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfSyncExternalBranchJobAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/syncexternalbranchjobs',
            query: {
                'externalBranchId': externalBranchId,
                'status': status,
                'fromDate': fromDate,
                'toDate': toDate,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewSyncExternalBranchJobs`
     * @returns GetSyncExternalBranchJobStatusLogsAdminResponse OK
     * @throws ApiError
     */
    public static getSyncExternalBranchJobStatusLogsAsyncAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<GetSyncExternalBranchJobStatusLogsAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/syncexternalbranchjobs/{id}/status-logs',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `CancelSyncExternalBranchJobs`
     * @returns any OK
     * @throws ApiError
     */
    public static cancelSyncExternalBranchJobAsyncAdmin({
        id,
    }: {
        id: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/syncexternalbranchjobs/{id}/cancel',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
